const apiEndpoints = {
  login: 'admin/login',
  category: 'category',
  subcategoryCreate: 'category/subcategory',
  categoryOrder: 'category/order',
  item: 'item',
  size: 'size',
  optionToSize: 'option_to_size',
  option: 'option',
  optionValue: 'option_value',
  availability: 'availability',
  availabilityToItem: 'availability/item',
  availabilityToCategory: 'availability/category',
  availabilityToSpecialSize: 'availability/special_size',
  availabilityToSpecialCategory: 'availability/special_category',
  specialCategory: 'special_category',
  specialSize: 'special_size',
  reservations: 'reservations',
  reservationGuests: 'reservations/guests',
  reservationServicePeriods: 'reservations/service-periods',
  reservationAvailability: 'reservations/availability',
  reservationWaitlist: 'reservations/waitlist',
};

export default apiEndpoints;
